import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../constants/common'
import { useInfiniteItemsListLoader, useInitData } from '../../../hooks'
import { EntityProfileTabUpdates } from '../../Entity'

import { getUserProfileLogEvents } from './UserProfileTabUpdates.api'
import { USER_PROFILE_LOG_EVENTS_PAGE_SIZE } from './UserProfileTabUpdates.constants'
import { toTranslatedUpdates } from './UserProfileTabUpdates.utils'

function UserProfileTabUpdates({ userData }) {
  const { t } = useTranslation()

  const { availableSections } = useInitData()

  const userId = userData?.id

  const {
    getThresholdItemProps,
    hasError,
    items,
    loadingInitial,
    loadingMore,
  } = useInfiniteItemsListLoader({
    apiParams: {
      page_size: USER_PROFILE_LOG_EVENTS_PAGE_SIZE,
      profile_id: userId,
    },
    getData: getUserProfileLogEvents,
    loadPermission: Boolean(userId),
    withPagination: true,
  })

  const translatedItems = toTranslatedUpdates({
    availableSections,
    items: items ?? EMPTY_LIST,
    t,
  })

  return (
    <EntityProfileTabUpdates
      getThresholdItemProps={getThresholdItemProps}
      hasError={hasError}
      isLoading={loadingInitial}
      isLoadingMore={loadingMore}
      items={translatedItems}
    />
  )
}

export default UserProfileTabUpdates
